// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1K9Uq","title":"ClientReferral_title__26I4_","itemText":"ClientReferral_itemText__1pcWA"};